<script setup>
import { ref, watch, computed } from 'vue';
import { DataType as WorkflowDataType } from '../../../modules/workflows/app/types/generic-filter';
import { DataType as CoreDataType } from 'vince-core/types/common';

const props = defineProps({
    modelValue: CoreDataType,
    dataType: {
        type: String,
        default: 'STRING'
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:modelValue']);

const internalValue = ref(props.modelValue);

watch(
    () => props.modelValue,
    (newVal) => {
        internalValue.value = newVal;
    },
    { immediate: true }
);

watch(
    internalValue,
    (newVal) => {
        if (newVal !== props.modelValue) {
            emit('update:modelValue', newVal);
        }
    }
);


const isNumber = computed(() =>
    props.dataType === CoreDataType.NUMERIC ||
    props.dataType === CoreDataType.DATE ||
    props.dataType === WorkflowDataType.NUMBER
);
</script>

<template>
    <div>
        <VLInputNumber
            v-if="isNumber"
            v-model="internalValue"
            :use-grouping="false"
            :disabled="props.disabled"
            fluid
        />
        <VLInputText
            v-else
            v-model="internalValue"
            :disabled="props.disabled"
            fluid
        />
    </div>
</template>
